import React, { useState, useEffect, useCallback } from "react";
import { Col, Row, Image } from "react-bootstrap";
import { ChartsComponent } from "../../../reusableComponent";

// charts constants
import { FIRST_PIE_CHART_HELPER } from "./pie.first";
import { FIRST_PIE_CHART_DASHBOARD_HELPER } from "./pie.first.dashboard";
import { SECOND_PIE_CHART_HELPER } from "./pie.second";
import { SECOND_PIE_CHART_DASHBOARD_HELPER } from "./pie.second.dashboard";
import { FIRST_GRAPH_CHART_HELPER } from "./graph.third";
import { THIRD_PIE_CHART_HELPER } from "./pie.fourth";
import { FOURTH_PIE_CHART_HELPER } from "./pie.fifth";
import LazyLoad from "react-lazy-load";
import { getLocalstorage } from "../../../../helper";

// actions
import {
  getProjectsByImplementationModeAction,
  getUnderImplementationProjectsByAction,
  getProjectsStatusWithRespectToIssueStatusAction,
  getOpenProjectsByImplementationModeAction
} from "../../../../actions/reports.action";

// helper
import ChartsDetails from "./ChartsDetails";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { SECOND_PIE_CHART_RESPONSIVE_HELPER } from "./pie.second.responsive";
import { FIRST_PIE_CHART_RESPONSIVE_HELPER } from "./pie.first.responsive";

const SecondPage = React.memo(function SecondPage({
  displayOnDashboard = false,
  dashboardClass,
  isDesktopView,
  history
}) {
  const [projectImplementationMode, setProjectImplementationMode] = useState({
    isLoading: false,
    data: []
  });
  const [
    underImplementationProjects,
    setUnderImplementationProjects
  ] = useState({
    isLoading: false,
    pieData: [],
    graphData: []
  });
  const [
    projectsStatusWithRespectToIssue,
    setProjectsStatusWithRespectToIssue
  ] = useState({
    isLoading: false,
    data: []
  });
  const [
    openProjectsByImplementationMode,
    setOpenProjectsByImplementationMode
  ] = useState({
    isLoading: false,
    data: []
  });
  const [updateValue, setUpdateValue] = useState(0);
  const checkedValue = getLocalstorage("march24");

  useEffect(() => {
    getProjectsByImplementationModeApisData();
    getUnderImplementationProjectsApisData();
    getProjectsStatusWithRespectToIssueStatusApiData();
    getOpenProjectsByImplementationModeData();
  }, [checkedValue]);

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [updateValue]);

  const onScroll = () => {
    let currentOffset = (window && window.scrollY) || 0;
    if (isDesktopView) {
      if (currentOffset > 1100 && currentOffset < 1300) {
        setUpdateValue(updateValue + 1);
      }
    }
    if (
      (currentOffset > 350 && currentOffset < 450) ||
      (currentOffset > 1050 && currentOffset < 1150)
    ) {
      setUpdateValue(updateValue + 1);
    }
  };

  const getProjectsByImplementationModeApisData = async () => {
    // loading started
    setProjectImplementationMode({ isLoading: true, data: [] });
    // get data
    const resp = await getProjectsByImplementationModeAction(
      undefined,
      checkedValue
    );
    // loading completed
    setProjectImplementationMode({
      isLoading: false,
      data: displayOnDashboard
        ? isDesktopView
          ? FIRST_PIE_CHART_DASHBOARD_HELPER(resp.data, history)
          : FIRST_PIE_CHART_RESPONSIVE_HELPER(resp.data, history)
        : FIRST_PIE_CHART_HELPER(resp.data)
    });
  };

  const getUnderImplementationProjectsApisData = async () => {
    try {
      // loading started
      setUnderImplementationProjects({
        isLoading: true,
        pieData: [],
        graphData: []
      });
      // get data
      const issueReportResp = await getUnderImplementationProjectsByAction();
      // loading completed
      setUnderImplementationProjects({
        isLoading: false,
        pieData: displayOnDashboard
          ? isDesktopView
            ? SECOND_PIE_CHART_DASHBOARD_HELPER(
                issueReportResp.data,
                history
              ) || []
            : SECOND_PIE_CHART_RESPONSIVE_HELPER(
                issueReportResp.data,
                history
              ) || []
          : SECOND_PIE_CHART_HELPER(issueReportResp.data) || [],
        graphData: FIRST_GRAPH_CHART_HELPER(issueReportResp.data) || []
      });
    } catch (error) {
      console.error(error);
    }
  };

  //
  const getProjectsStatusWithRespectToIssueStatusApiData = async () => {
    // loading started
    setProjectsStatusWithRespectToIssue({ isLoading: true, data: [] });
    // get data
    const resp = await getProjectsStatusWithRespectToIssueStatusAction();
    // loading completed

    if (displayOnDashboard) {
      setProjectsStatusWithRespectToIssue({
        isLoading: false,
        data: resp.data || []
      });
    } else {
      setProjectsStatusWithRespectToIssue({
        isLoading: false,
        data: THIRD_PIE_CHART_HELPER(resp.data) || []
      });
    }
  };

  const getOpenProjectsByImplementationModeData = async () => {
    // loading started
    setOpenProjectsByImplementationMode({ isLoading: true, data: [] });
    // get data
    const resp = await getOpenProjectsByImplementationModeAction();
    // loading completed

    if (displayOnDashboard) {
      setOpenProjectsByImplementationMode({
        isLoading: false,
        data: resp.data || []
      });
    } else {
      setOpenProjectsByImplementationMode({
        isLoading: false,
        data: FOURTH_PIE_CHART_HELPER(resp.data) || []
      });
    }
  };

  let settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false
  };

  return (
    <>
      {/* PDF First Section Start */}
      {!isDesktopView && displayOnDashboard ? (
        <Slider {...settings}>
          <ChartsComponent
            isLoading={projectImplementationMode.isLoading}
            chartConfig={projectImplementationMode.data}
            displayOnDashboard={displayOnDashboard}
            displayTitle="Projects Under Construction"
            updateValue={updateValue}
          />
          <ChartsComponent
            isLoading={underImplementationProjects.isLoading}
            chartConfig={underImplementationProjects.pieData}
            displayOnDashboard={displayOnDashboard}
            displayTitle="Sector Distribution"
            updateValue={updateValue}
          />
        </Slider>
      ) : (
        <div className={`charts-sections first-section ${dashboardClass}`}>
          <div className="chart">
            {/* Section */}
            <div className="charts-sections-left even">
              <ChartsComponent
                isLoading={projectImplementationMode.isLoading}
                chartConfig={projectImplementationMode.data}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Projects Under Construction"
                updateValue={updateValue}
              />
              <section id="second-page-pie-labels-1" />
            </div>

            {/* Right Section */}
            <div className={`charts-sections-right odd ${dashboardClass}`}>
              <ChartsComponent
                isLoading={underImplementationProjects.isLoading}
                chartConfig={underImplementationProjects.pieData}
                displayOnDashboard={displayOnDashboard}
                displayTitle="Sector Distribution"
                updateValue={updateValue}
              />
              <section id="second-page-pie-labels-2" />
            </div>
          </div>
        </div>
      )}

      {/* PDF First Section End */}

      {displayOnDashboard ? null : (
        <div className={"charts-sections second-section"}>
          {/* Right Section */}
          <ChartsComponent
            isLoading={underImplementationProjects.isLoading}
            chartConfig={underImplementationProjects.graphData}
            displayOnDashboard={displayOnDashboard}
          />
          <section id="second-page-pie-labels-3" />
        </div>
      )}

      {/* PDF Third Section End */}
      {displayOnDashboard ? (
        <ChartsDetails
          openProjectsByImplementationMode={
            openProjectsByImplementationMode &&
            openProjectsByImplementationMode.data
          }
          projectsStatusWithRespectToIssue={
            projectsStatusWithRespectToIssue &&
            projectsStatusWithRespectToIssue.data
          }
          isDesktopView={isDesktopView}
        />
      ) : (
        <div className={`charts-sections first-section ${dashboardClass}`}>
          <div className="chart">
            {/* Section */}
            <div className="charts-sections-left even">
              <ChartsComponent
                isLoading={projectsStatusWithRespectToIssue.isLoading}
                chartConfig={projectsStatusWithRespectToIssue.data}
                displayOnDashboard={displayOnDashboard}
              />
              <section id="second-page-pie-labels-1" />
            </div>

            {/* Right Section */}
            <div className={`charts-sections-right odd ${dashboardClass}`}>
              <ChartsComponent
                isLoading={openProjectsByImplementationMode.isLoading}
                chartConfig={openProjectsByImplementationMode.data}
                displayOnDashboard={displayOnDashboard}
              />
              <section id="second-page-pie-labels-2" />
            </div>
          </div>
        </div>
      )}
    </>
  );
});

export { SecondPage };
